/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const FilesGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  OrgId: "org_id",
} as const;
export type FilesGroupBy = ClosedEnum<typeof FilesGroupBy>;

/** @internal */
export const FilesGroupBy$inboundSchema: z.ZodNativeEnum<typeof FilesGroupBy> =
  z.nativeEnum(FilesGroupBy);
/** @internal */
export const FilesGroupBy$outboundSchema: z.ZodNativeEnum<typeof FilesGroupBy> =
  FilesGroupBy$inboundSchema;
